import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => {
  return {
    root: {},
    tabPanel: {
      padding: 0,
    },
  };
});